import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AccordionList, Accordion } from 'onefaceui-react-components';

import Signature from './Signature.jsx';
import Geocode from './Geocode.jsx';
import LocationInstructions from './LocationInstructions';
import StopInstructions from './StopInstructions';
import { getResourceTo } from 'react/utils/utils';

const StopDetailsPopupAccordion = (props) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const {
    routeId,
    stopId,
    hasSignature,
    geocodeIsEnabled,
    deliveryInstructions,
    instructions,
    stop
  } = props;

  const handleSelectAccordion = useCallback((index) => {
    setSelectedIndex((actualIndex) => (actualIndex !== index ? index : -1));
  }, []);

  useEffect(() => {
    handleSelectAccordion(geocodeIsEnabled ? 1 : -1);
  }, [geocodeIsEnabled]);

  return (
    <AccordionList>
      <Accordion
        isVisible={hasSignature}
        label={getResourceTo('Stop.Signature.title')}
        customOnClick={handleSelectAccordion}
        isExpanded={selectedIndex === 0}
      >
        <Signature routeId={routeId} stopId={stopId}/>
      </Accordion>
      <Accordion
        isVisible={geocodeIsEnabled}
        label={getResourceTo('Stop.Geocode.Title')}
        customOnClick={handleSelectAccordion}
        isExpanded={selectedIndex === 1}
      >
        <Geocode routeId={routeId} stopId={stopId} stop={stop}/>
      </Accordion>
      <Accordion
        isVisible={deliveryInstructions}
        label={getResourceTo('Stop.popup.locationInstructionsExpansionBox')}
        customOnClick={handleSelectAccordion}
        isExpanded={selectedIndex === 2}
      >
        <LocationInstructions routeId={routeId} stopId={stopId} stop={stop} />
      </Accordion>
      <Accordion
        isVisible={instructions}
        label={getResourceTo('Stop.popup.stopInstructionsExpansionBox')}
        customOnClick={handleSelectAccordion}
        isExpanded={selectedIndex === 3}
      >
        <StopInstructions routeId={routeId} stopId={stopId} stop={stop} />
      </Accordion>
    </AccordionList>
  );
}

StopDetailsPopupAccordion.propTypes = {
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  hasSignature: PropTypes.bool.isRequired,
  geocodeIsEnabled: PropTypes.bool.isRequired,
  deliveryInstructions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired,
  instructions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired,
  stop: PropTypes.object.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({
  hasSignature: stopDetailsPopup.getIn([String(routeId), String(stopId), 'stop', 'hasSignature'], false),
  geocodeIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'geocodeIsEnabled'], false),
  deliveryInstructions: stopDetailsPopup.getIn([String(routeId), String(stopId), 'stop', 'location', 'deliveryInstructions'], false),
  instructions: stopDetailsPopup.getIn([String(routeId), String(stopId), 'stop', 'instructions'], false),
});

export default connect(mapStateToProps, null)(StopDetailsPopupAccordion);

